import { faArrowLeft, faCopy, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function OrderPlaced() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    function parseQueryParam(name) {
      const params = new URLSearchParams(window.location.search);
      const v = params.get(name);
      if (!v) return null;
      try {
        return JSON.parse(decodeURIComponent(v));
      } catch {
        return null;
      }
    }
    const parsed = parseQueryParam("data");
    if (!parsed) {
      setError(true);
    } else {
      setData(parsed);
    }
  }, []);

  // function formatAmount(amount, currency) {
  //   if (amount === null || amount === undefined) return "—";
  //   if (typeof amount === "number")
  //     return (
  //       amount.toLocaleString(undefined, {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 8,
  //       }) + " " + (currency || "")
  //     );
  //   return amount + (currency ? " " + currency : "");
  // }

  function statusClass(status) {
    status = (status || "").toLowerCase();
    if (status === "completed") return "success";
    if (status === "pending") return "pending";
    return "failed";
  }

  const handleCopy = () => {
    if (!data) return;
    navigator.clipboard.writeText(JSON.stringify(data, null, 2)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    });
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: "#f4f7fa" }}>
      {/* Brand Row */}
      <div className="brand-row text-center" style={{ padding: "2.3rem 0 0.8rem" }}>
        <span className="brand-logo" style={{ fontSize: "1.6rem", color: "#286ee6" }}>
          <i className="fa-solid fa-clapperboard"></i>
        </span>
        <span
          className="brand-name"
          style={{ fontSize: "1.4rem", fontWeight: "700", color: "#153468", letterSpacing: "1px" }}
        >
          StreamFlix
        </span>
      </div>

      {/* Back Action */}
      <div className="top-actions d-flex justify-content-start align-items-center mx-auto" style={{ maxWidth: "500px" }}>
        <button onClick={() => navigate('/')} className="back-btn btn" style={{
          borderRadius: "23px", border: "1.6px solid #2876e1",
          color: "#2876e1", background: "#e7f1fa", fontWeight: 500,
          marginBottom: "0.5rem", fontSize: "1rem", padding: "0.38em 1.45em"
        }}>
          <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
        </button>
      </div>

      {/* Main Card */}
      <div className="success-main-card" style={{
        maxWidth: "500px", margin: "1.2rem auto 2rem",
        background: "#fff", borderRadius: "15px", padding: "2.4rem 2rem",
        boxShadow: "0 12px 40px 0 #dbe8fd2b"
      }}>
        <div className="text-center">
          <div className="checkmark mx-auto mb-3" style={{
            width: "100px", height: "100px", borderRadius: "50%",
            background: "#e6f9ed", display: "flex",
            alignItems: "center", justifyContent: "center"
          }}>
            <svg viewBox="0 0 52 52" width="60" height="60" stroke="#2fae6e" strokeWidth="6"
              fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 27 l10 10 l14 -14" strokeDasharray="70" strokeDashoffset="70">
                <animate attributeName="stroke-dashoffset" from="70" to="0" dur="0.63s" fill="freeze" />
              </path>
            </svg>
          </div>
          <h2 className="fw-bold mb-1" style={{ color: "#15233c" }}>Order Placed</h2>
          <p className="text-muted mb-2">Your transaction was successful.</p>
        </div>

        <hr />

        {/* Order Details */}
        {data ? (
          <div className="order-detail-row" style={{
            background: "#f6f9fd", borderRadius: "8px",
            padding: "1.2rem 1rem", fontSize: "1.07rem", color: "#485070"
          }}>
            <div className="row g-3">
              <div className="col-7 text-start">
                <b>Payment Mode:</b> <span>{data?.response?.paymentMode || "—"}</span>
              </div>
              <div className="col-5 text-end">
                <span className={`status-badge ${statusClass(data.status)}`} style={{
                  fontSize: "0.92rem", padding: "0.45em 1.3em",
                  borderRadius: "50px", fontWeight: 600, textTransform: "uppercase"
                }}>
                  {data?.response?.status || "unknown"}
                </span>
              </div>
            </div>
            <div className="row g-3 mt-2">
              <div className="col-7 text-start">
                <b>Order Id:</b>{" "}
                <span>{data?.response?.offerId}</span>
              </div>
              <div className="col-5 text-end">
                <b>Currency:</b> <span>{data?.response?.currency || ""}</span>
              </div>
            </div>
          </div>
        ) : (
          error && (
            <div className="alert alert-warning text-center mt-4">
              Order data not found or the URL is malformed.
            </div>
          )
        )}

        {/* Buttons */}
        <div className="d-flex justify-content-between flex-wrap gap-2 mb-3">
          <button
            onClick={handleCopy}
            className={`flat-btn copy-btn btn px-4 ${copied ? "copied" : ""}`}
            aria-pressed={copied}
            style={{
              borderRadius: "23px", border: "1.5px solid #24e469",
              color: copied ? "#17a13a" : "#24e469",
              background: copied ? "#e4ffe3" : "#eafcf4"
            }}
          >
            {copied ? "Copied!" : <><FontAwesomeIcon icon={faCopy} /> Copy Raw Data</>}
          </button>
          <button href="#" onClick={() => navigate('/')} className="flat-btn home-btn btn px-4"
            style={{ borderRadius: "23px", background: "#24e469", color: "#fff", border: "none" }}>
            <FontAwesomeIcon icon={faHome} />Go Home
          </button>
        </div>

        {/* Raw JSON */}
        <div className="json-label" style={{
          color: "#8191a2", fontSize: ".82rem",
          marginTop: "1.4rem", marginBottom: "0.3rem", fontWeight: 600
        }}>
          Full Payload
        </div>
        <div className="json-box" style={{
          background: "#f8f9fa", borderRadius: "6px",
          padding: "0.85rem 1.2rem", fontFamily: "monospace", fontSize: "0.93rem"
        }}>
          {data ? JSON.stringify(data, null, 2) : "No valid data parsed from query string."}
        </div>
      </div>
    </div>
  );
}
